"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
const staticExperiences = [{
  id: "static-1",
  title: "In-Spa Experiences",
  description: "Immerse yourself in our tranquil environment with treatments designed to rejuvenate mind and body.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/in_spa_experience.png",
  link: "/ExperiencesPage"
}, {
  id: "static-2",
  title: "Book Club",
  description: "Join our community of wellness enthusiasts to discuss inspiring literature and share personal growth journeys.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/wellness_book_club.png",
  link: "/ExperiencesPage"
}, {
  id: "static-3",
  title: "Wellness Retreats",
  description: "Escape the everyday with our curated retreats, offering deep relaxation and holistic healing practices.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/wellness_retreats.png",
  link: "/ExperiencesPage"
}];
function ExperienceGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] rounded-2xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  const displayItems = posts.length > 0 && !error ? posts : staticExperiences;
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6">
      {displayItems.map((item, i) => {
      const isStatic = 'image' in item;
      const title = isStatic ? item.title : item.title;
      const description = isStatic ? item.description : item.customFields?.description || item.excerpt?.replace(/<[^>]*>?/gm, '') || "";
      const imageUrl = isStatic ? item.image : item.featuredImage || item.customFields?.image || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/generic_wellness_experience.png";
      const itemLink = isStatic ? item.link : item.link || "/ExperiencesPage";
      return <Link key={item.id} to={itemLink} data-index={i} className="block group outline-none">
            <Card className="h-full overflow-hidden bg-card/40 backdrop-blur-md border-border/50 shadow-sm transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-md group-focus-visible:ring-2 group-focus-visible:ring-ring">
              <div className="relative overflow-hidden">
                <AspectRatio ratio={4 / 3}>
                  <img src={imageUrl} alt={title} className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" loading="lazy" {...isStatic || !item.featuredImage ? {
                "data-wvc-srcset": `${imageUrl}-wvc-srcset`,
                "data-wvc-sizes": `${imageUrl}-wvc-sizes`
              } : {}} />
                </AspectRatio>
              </div>
              <CardHeader>
                <CardTitle className="text-xl font-default">{title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground line-clamp-3 font-sans">
                  {description}
                </p>
              </CardContent>
            </Card>
          </Link>;
    })}
    </div>;
}
export default function ExperienceShowcase() {
  const wp_query_params = {
    post_type: "experience",
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="experienceshowcase" className="py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[var(--color-green-accent)]/5 rounded-full blur-3xl -z-10 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 mb-16 text-center">
        <h2 className="text-4xl md:text-5xl font-default text-foreground mb-4 tracking-tight">
          M/O Experiences
        </h2>
        <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
          Discover our curated selection of premium wellness journeys designed to elevate your self-care routine.
        </p>
      </div>

      <PostsProvider wp_query={{
      post_type: "experience",
      per_page: 3
    }}>
        <ExperienceGrid />
      </PostsProvider>

      <div className="mt-16 flex justify-center">
        <Button asChild size="lg" className="bg-green-accent rounded-full px-8 h-12 text-base font-sans">
          <Link to="/ExperiencesPage">Explore Experiences</Link>
        </Button>
      </div>
    </section>;
}